import { useState } from 'react'
import { Element } from '@phrasee/phrasee-typings/typings/futurama/element'
import cx from 'classnames'

import Tooltip from 'common/components/Tooltip'
import { Settings as SettingsIcon } from 'common/icons'

import ElementVerticalDotMenu from './ElementVerticalDotMenu'

type Props = {
  isConfigurable: boolean
  isSelected: boolean
  isRemoveOptionShown?: boolean
  element?: Element
  className?: string
}

const ElementActionsMenu = ({
  isConfigurable,
  element,
  isSelected,
  isRemoveOptionShown,
  className,
}: Props) => {
  const [isVerticalMenuOpen, setIsVerticalMenuOpen] = useState(false)

  const isCustomized = element?.settings_customisation

  return (
    <div className={cx('mr-0 ml-auto flex items-start', className)}>
      {isConfigurable && (
        <ElementVerticalDotMenu
          isSelected={isSelected}
          element={element}
          isRemoveOptionShown={isRemoveOptionShown}
          isMenuOpen={isVerticalMenuOpen}
          onMenuChange={({ open }) => setIsVerticalMenuOpen(open)}
        />
      )}
      {isCustomized && (
        <Tooltip overlay="Uses custom brief">
          <SettingsIcon
            isDefaultColor={false}
            size={6}
            className={cx({
              'text-coolGray-400': !isSelected,
              'text-orange-400': isSelected,
            })}
          />
        </Tooltip>
      )}
    </div>
  )
}

export default ElementActionsMenu
